module.exports = __webpack_public_path__ + "static/media/blackbox_warning.26fdc3a5.jpg";